<container-element [ngSwitch]="type" class="seds-buttons">
  <button
    [style.width]="width"
    *ngSwitchCase="typeBasic"
    [disabled]="disabled"
    [ngClass]="[size, color]"
    mat-raised-button
    disableRipple>
    <ng-container *ngTemplateOutlet="buttonContent; context: { $implicit: 'white' }"></ng-container>
  </button>
  <button
    [style.width]="width"
    *ngSwitchCase="typeOulined"
    [disabled]="disabled"
    [ngClass]="[size, color]"
    mat-stroked-button
    disableRipple>
    <ng-container *ngTemplateOutlet="buttonContent; context: { $implicit: 'primary' }"></ng-container>
  </button>
  <button
    [style.width]="width"
    *ngSwitchCase="typeFlat"
    [disabled]="disabled"
    [ngClass]="[size, color]"
    mat-flat-button
    disableRipple>
    <ng-container
      *ngTemplateOutlet="
        buttonContent;
        context: {
          $implicit:
            color === 'secondary-flat-button' ? 'secondary' : color === 'accent-flat-button' ? 'accent' : 'primary',
        }
      "></ng-container>
  </button>
  <button
    *ngSwitchCase="typeFab"
    [disabled]="disabled"
    [ngClass]="[size, color]"
    class="seds-fab-button"
    mat-fab
    disableRipple>
    <mat-icon>{{ iconName }}</mat-icon>
  </button>
</container-element>

<ng-template #buttonContent let-spinnerclass>
  <div class="seds-flex seds-items-center seds-flex-row seds-justify-center seds-items-center">
    <div
      *ngIf="loading"
      class="seds-m-2 button-spinner"
      [ngClass]="{
        'custom-spinner-secondary':
          (type === 'outlined' || type === 'flat') &&
          (color === 'accent-flat-button' ||
            color === 'accent-outlined-button' ||
            color === 'secondary-flat-button' ||
            color === 'secondary-outlined-button'),
        'custom-spinner-primary':
          (type === 'outlined' || type === 'flat') &&
          (!color || color === 'primary-flat-button' || color === 'primary-outlined-button'),
        'custom-spinner-tertiary':
          (type === 'outlined' || type === 'flat') &&
          (color === 'tertiary-flat-button' || color === 'tertiary-outlined-button'),
        'custom-spinner-white': type === 'basic' || type === 'fab'
      }">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
    <mat-icon class="icon-size seds-mr-2" *ngIf="iconName && iconPosition === iconLeft && !loading">{{
      iconName
    }}</mat-icon>
    <span class="seds-align-middle seds-button-label">{{ title }}</span>
    <mat-icon class="seds-ml-2 icon-size" *ngIf="iconName && iconPosition === iconRight && !loading">{{
      iconName
    }}</mat-icon>
  </div>
</ng-template>
